// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"0de09977","997":"80295d1c"}[chunkId] + ".chunk.css";
};